.stepForm {
	min-width: 1100px;
	width: 65%;
}

.stepForm img {
	display: none;
}

@media (max-width: 1200px) {
	.stepForm {
		width: 100vw;
		min-width: 100vw;
	}
}
